import * as careGapsAPI from "../api/careGapsApi";
import * as types from "../constants/actionTypes";
import { call, put, select, takeLatest, all } from "redux-saga/effects";
import { logAPI } from "../api/andyliticsApi";

export default function* careGapsSaga() {
    yield takeLatest(types.GET_PATIENT_SCHEDULING_PERMISSIONS_START, getPatientSchedulingPermissions);
}

export function* getPatientSchedulingPermissions(params) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    
    if (stateData && params) {
        const { token, body, successCb, failCb } = params;
        try {
            const response = yield call(careGapsAPI.getPatientSchedulingPermissions, token, body);

            logAPI("MBHWeb.Saga.CareGaps.GetPatientSchedulingPermissions.Get", start, null);
            yield all([put({ type: types.GET_PATIENT_SCHEDULING_PERMISSIONS_SUCCESS, schedulingPermissions: response })]);
            if (successCb) {
                successCb();
            }
        }
        catch (err) {
            yield put({ type: types.GET_PATIENT_SCHEDULING_PERMISSIONS_FAILURE, error: err });
            logAPI("MBHWeb.Saga.CareGaps.GetPatientSchedulingPermissions.Failure", start, null, err);
            if (failCb) {
                failCb();
            }
        }
    }
    else {
        console.log("MBHWeb.Saga.CareGaps: REDUX_DOWN");
    }
}
